/**
 * Agent Context Types
 * Defines agent items that can be mentioned with @ in chat input
 */

export type AgentContextItem = {
  id: string
  name: string
  description?: string
  icon?: string
}

/**
 * Convert agent to context item format
 */
export function agentToContextItem(agent: {
  id: string
  name: string
  description?: string | null
}): AgentContextItem {
  return {
    id: agent.id,
    name: agent.name,
    description: agent.description || undefined,
    icon: "🤖",
  }
}
